<template>
    <div id="tourschool">
        <img class="banner-image-height" :src="wpData.acf.bannerimage">  
        <b-container>
            <b-row class="tourSchool-pos container">
                <b-col cols="12" lg="3" md='12' class="backgroundImage sched-course-img" style="background-image: url('https://live-letas.ocs-software.com/wp-content/uploads/2020/01/tourschool-pic.png')">
                </b-col>
                <b-col cols="12" lg="9" md="12" class="tourSchool-banner-back">
                    <div class="tour-school-info">
                        <h3 class="tourn-name ng-binding">
                            {{wpData.acf.top_section_title_}} 
                        </h3>
                        <a class="tourSchool-Link" :href="wpData.acf.tour_school_button_text_link">
                            <div class="button-top-tourSchool">
                                <h3 class="tourschool-button-text">
                                {{wpData.acf.tour_school_button_text}} <div class="TourSchool-button-arrow"></div>
                                </h3>
                            </div>
                        </a>
                        <a class="download-tourSchool" :href="wpData.acf.tour_school_download_regulations_text_link">
                            <h4 class="tour-school-download">
                                {{wpData.acf.tour_school_download_regulations_text}} 
                            </h4>
                        </a>
                    </div>
                </b-col>
            </b-row>
            <b-row class="TournamentTopBlock">
                <b-col cols="12" lg="6" md='12' v-for="(data, index) in tournaments.slice(27,28)" :key="index">
                    <div v-if="data.class_group == 'PRE'">
                        <div class="playerprofile-blockList">
                            <h3 class="tour-school-tag">{{data.short_name}}</h3>
                        </div>
                        <div>
                            <table class="table table-striped">
                                <thead>
                                    <tr class="tourSchool-tr">
                                        <th scope="col" class="thTitles" >Venue</th>
                                        <th scope="col" class="thTitles" >Rounds 1 - {{data.rounds}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="tourSchool-tr-venue">
                                        <td scope="row">{{data.course}}</td>
                                        <td>{{data.dates}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" lg="6" md='12' v-for="(data, index) in tournaments.slice(28,29)" :key="index">
                    <div v-if="data.class_group == 'PRE'">
                        <div class="playerprofile-blockList">
                            <h3 class="tour-school-tag">{{data.short_name}}</h3>
                        </div>
                        <div>
                            <table class="table table-striped">
                                <thead>
                                    <tr class="tourSchool-tr">
                                        <th scope="col" class="thTitles" >Venue</th>
                                        <th scope="col" class="thTitles" >Rounds 1 - {{data.rounds}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="tourSchool-tr-venue">
                                        <td scope="row">{{data.course}}</td>
                                        <td>{{data.dates}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="12" lg="6" md='12'>
                    <h3 class="top-of-tour-school-title">
                        {{wpData.acf.top_section_title_}}
                    </h3>
                    <div class="top-of-tour-school-descript">
                        <p  v-html="wpData.acf.top_section_description"></p>
                    </div>
                    <div>
                        <table class="table table-striped">
                            <tbody>
                                <tr class="datesTr">
                                    <td class="venueName" scope="row">Practice for Pre-Qualifying</td>
                                    <td>13 and 14 Jan</td>
                                </tr>
                                <tr class="datesTr">
                                    <td class="venueName">Pre-Qualifying</td>
                                    <td>15,16,17 and 18 Jan</td>
                                </tr>
                                <tr class="datesTr">
                                    <td class="venueName">Pro-Am with approximately 20 professinals</td>
                                    <td>19 Jan</td>
                                </tr>
                                <tr class="datesTr">
                                    <td class="venueName">Practise Final Qualifying</td>
                                    <td>20, 21 Jan</td>
                                </tr>
                                <tr class="datesTr">
                                    <td class="venueName">Final Qualifying</td>
                                    <td>22,23,24,25,26 Jan</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </b-col>
                <b-col cols="12" lg="6" md='12'>
                    <a href="https://ocs-sport.ams3.cdn.digitaloceanspaces.com/let/2019/11/QUALIFYING-SCHOOL-2020_Hotel.pdf" target="_blank">
                        <div class="backgroundLinks">
                            <h2 class="rightLinks">Qualifying School Hotel 2021 
                                <font-awesome-icon
                                class="icon"
                                :icon="['fa', 'chevron-right']"/>
                            </h2>
                        </div>
                    </a>
                    <a href="https://ocs-sport.ams3.cdn.digitaloceanspaces.com/let/2019/11/Plan-of-Las-Lomas-apartments.pdf" target="_blank">
                        <div class="backgroundLinks">
                            <h2 class="rightLinks">Plan Of Las Lomas Apartments
                                <font-awesome-icon
                                class="icon"
                                :icon="['fa', 'chevron-right']"/>
                            </h2>
                        </div>
                    </a>
                    <a href="https://ocs-sport.ams3.cdn.digitaloceanspaces.com/let/2019/11/2020_TOURSCHOOL_REGS_DEF2_.pdf" target="_blank">
                        <div class="backgroundLinks">
                            <h2 class="rightLinks">Information And Regulations
                                <font-awesome-icon
                                class="icon"
                                :icon="['fa', 'chevron-right']"/>
                            </h2>
                        </div>
                    </a>
                </b-col>
            </b-row>
            <b-row class="AllComps">
                <b-col cols="12" lg="12" md='12'>
                    <p v-html="wpData.acf.all_comps"></p>
                </b-col>
            </b-row>
            <b-row class="bottomImagesDiv">
                <b-col cols="12" lg="4" md='12'>
                    <img class="bottomImages" :src="wpData.acf.bottomimageone">
                </b-col>
                <b-col cols="12" lg="4" md='12'>
                    <img class="bottomImages" :src="wpData.acf.bottomimagetwo">
                </b-col>
                <b-col cols="12" lg="4" md='12'>
                    <img class="bottomImages" :src="wpData.acf.bottomimagethree">
                </b-col>
            </b-row>
        </b-container>
        <div class="backgroundGrey">
            <b-container>
                <b-row>
                    <b-col cols="12" lg="5" md='12'>
                        <div class="tour-school-outer-title">
                            <h3 class="tour-school-title">{{wpData.acf.tour_school_title}}</h3>
                        </div>
                        <div class="tour-school-descript">
                            <p v-html="wpData.acf.tour_school_descript"></p>
                        </div>
                    </b-col>
                    <b-col cols="12" lg="7" md="12">
                        <iframe width="560" height="315" :src="wpData.acf.tour_school_youtube_video" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
import axios from "axios";
export default {
  name: "tourschool",
  props: ["season", 'config'],
  data() {
    return {
        wpData: [],
        tournaments: [],
    };
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_WPAPI_URL+"wp/v2/pages/86"+ "?randomadd=" + new Date().getTime())
      .then((response) => {
        this.wpData = response.data;
        return axios.get(
          process.env.VUE_APP_TIC_BASE+ this.season + "/tmticx?randomadd="+ new Date().getTime())
      })
      .then((response) => {
        this.tournaments = response.data.tournaments.tournaments_entry;
      })
  },
}
</script>

<style scoped>
iframe {
    width: 100%;
    height: 355px;
    margin-top: 70px;
}
.tour-school-outer-title {
    margin-top: 6em;
}
.tour-school-descript > p {
    text-align: right;
    font-size: 11pt;
    color: #333;
}
h3.tour-school-title {
    text-align: right;
    background: #95c93d;
    color: #fff;
    padding: 20px 30px;
    font-size: 15pt;
}
h3.see-all-videos-TourSchool {
    text-align: right;
}
.backgroundGrey {
    background-color: #f2f2f2;
    height: 500px;
}
svg.icon.svg-inline--fa.fa-chevron-right.fa-w-10 {
    float: right;
    margin-right: 30px;
    margin-top: 3px;
}
.backgroundLinks {
    background-color: #95c93d;
    width: 350px;
    float: right;
    margin-bottom: 15px;
}
h2.rightLinks {
    color: #fff;
    font-size: 13pt;
    font-weight: 400;
    padding: 25px 15px 25px 15px;
    margin-bottom: 0;
    position: relative;
    top: -2px;
}
.bottomImagesDiv {
    margin-top: 30px;
    margin-bottom: 30px;
}
.bottomImages {
    width: 100%;
    max-height: 300px;
    height: 230px;
}
.AllComps {
    margin-top: 20px;
}
td.venueName {
    color: #95c93d;
    font-weight: 500;
}
tr.datesTr:nth-child(odd) {
    background-color: #fff9f9;
}
tr.datesTr:nth-child(even) {
    background-color: #ede8f3;
}
strong {
    font-size: 12pt;
}
.top-of-tour-school-descript>p {
    font-size: 11pt;
    color: #333;
    text-transform: capitalize;
}
h3.top-of-tour-school-title {
    color: #24023c;
    font-weight: 400;
    margin-top: 0;
    padding-bottom: 20px;
}
.table th, .table td {
    padding: 0.75rem;
    vertical-align: top;
    border-top: 0px solid #dee2e6;
}
.TournamentTopBlock {
    margin-top: 4em;
    margin-bottom: 2em;
}
th.thTitles {
    font-weight: 400;
}
.tourSchool-tr-venue {
    background-color: #ede9f3!important;
}
.tourSchool-tr {
    background-color: #7ba639;
    color: #fff;  
}
.playerprofile-blockList {
    background-color: #95c93d;
    padding: 0 0 0 10px;
    margin-top: 3px;
}
h3.tour-school-tag {
    color: #fff;
    padding: 15px 0 15px 0;
    font-size: 13pt;
    margin-top: 0;
    margin-bottom: 0;
}
.tour-school-info {
    margin-top: 2em;
    padding-left: 30px;
}
.tourSchool-pos {
    position: absolute;
    top: 300px;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 100%;
    margin: auto;
}
a.download-tourSchool>.tour-school-download:hover {
    color: #95c93d;
}
.tour-school-download {
    color: #a3a3a3;
    font-weight: 400;
    margin-top: 35px;
}
a.tourSchool-Link:hover {
    color: #fff;
}
.TourSchool-button-arrow {
    box-sizing: border-box;
    height: 15px;
    width: 15px;
    border-style: solid;
    border-color: #fff;
    border-width: 0 2px 2px 0;
    transform: rotate(313deg);
    transition: border-width 150ms ease-in-out;
    position: relative;
    top: -3px;
    display: inline-grid;
    left: 10px;
}
h3.tourschool-button-text {
    padding: 22px;
    color: #fff;
    font-weight: 400;
    margin-top: 30px;
}
a.tourSchool-Link>.button-top-tourSchool :hover {
    background-color: #95c93d;
}
.button-top-tourSchool {
    background-color: #95c93d;
    width: 60%;
}
.tourn-name {
    color: #95c93d;
}
.sched-course-img {
    height: 280px;
}
.banner-image-height {
    max-height: 600px;
    max-width: 100%;
    width: 100%;
}
.backgroundImage {
    background-repeat: no-repeat;
    background-size: cover;
}
.tourSchool-banner-back {
    background-color: #f2f2f2;
}

@media only screen and (max-width: 990px) {
    .backgroundLinks {
        background-color: #95c93d;
        width: 100%;
        float: right;
        margin-bottom: 15px;
    }
    .bottomImages {
        width: 100%;
        padding-top: 30px;
        max-height: initial;
        height: auto;
    }
    h3.tour-school-title {
        text-align: left;
        background: #95c93d;
        color: #fff;
        padding: 20px 30px;
        font-size: 15pt;
    }
    .tour-school-descript > p {
        text-align: left;
        font-size: 11pt;
        color: #333;
    }
    iframe {
        width: 100%;
        height: 355px;
        margin-top: 0;
    }
    .backgroundGrey {
        background-color: #f2f2f2;
        height: auto;
        padding-bottom: 100px;
    }
    .tourSchool-pos {
        position: absolute;
        top: 300px;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 100%;
        margin: auto;
        display: none;
    }
}
</style>
